import React from "react";
import { Card, Descriptions, Typography, Tooltip, Button, Space, Popconfirm, notification } from "antd";
import { CloseCircleOutlined, DeleteOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { useMutation } from "@apollo/react-hooks";
import { familyGql } from "../../graphql/family";
import { observer } from "mobx-react";
import { FamilyEditChild } from "./FamilyEditChild";
import { Store } from "../../store/Store";

export const UserInfoCard = observer(({ user, isActive, onUser, onChange }) => {
  const {
    orgRoles,
    user: { children },
  } = user;
  const noSchoolChildren = children
    .filter((c) => (!c.schoolId || c.schoolId === "-") && c.isNew !== false)
    .map((c) => {
      c.isNew = true;
      return c;
    });

  const [delFamilyship] = useMutation(familyGql.delFamilyship);
  const [delFamilyChild] = useMutation(familyGql.delFamilyChild);

  const onDelFamilyship = (childId) => {
    delFamilyship({
      variables: { childId, userId: user.user.id },
    })
      .then((res) => {
        notification.success({ message: `User updated.` });
        onChange && onChange();
      })
      .catch((err) => {});
  };

  const onDelFamilyChild = (childId) => {
    delFamilyChild({
      variables: { childId },
    })
      .then((res) => {
        notification.success({ message: `User updated.` });
        onChange && onChange();
      })
      .catch((err) => {});
  };

  const school = (o) => {
    return (
      <div key={o.org?.id} style={{ marginBottom: 15 }}>
        <Typography.Text strong>{o.org?.name}</Typography.Text>
        {o.isParent && (
          <Typography.Paragraph style={{ marginBottom: 2 }}>
            Parent {o.isLeader && <span> (Community Leader)</span>}
          </Typography.Paragraph>
        )}
        {o.isFundraiser && (
          <Typography.Paragraph style={{ marginBottom: 2 }}>Fundraiser ({o.fundOrgs.join(", ")})</Typography.Paragraph>
        )}
        {o.isTeacher && <Typography.Paragraph style={{ marginBottom: 2 }}>Teacher</Typography.Paragraph>}

        <div>
          {o.children.map((c) => (
            <div key={c.childId} className="child-line">
              <Typography.Text style={{ fontSize: 12 }} key={c.childId}>
                {c.name} {c.grade && <Typography.Text>({c.grade})</Typography.Text>} {c.email}{" "}
                {c.isNew && <Typography.Text> (new)</Typography.Text>}
              </Typography.Text>
              {!Store.isDivision && (
                <Space className="tools" size="small">
                  {!c.isNew && <FamilyEditChild child={c} />}
                  <Tooltip title="NO">
                    <Popconfirm
                      title="Are you sure to remove the family relation?"
                      onConfirm={() => onDelFamilyship(c.childId)}
                    >
                      <Button size="small" type="link" danger icon={<CloseCircleOutlined />} />
                    </Popconfirm>
                  </Tooltip>
                  <Popconfirm title="Are you sure to delete this child?" onConfirm={() => onDelFamilyChild(c.childId)}>
                    <Tooltip title="Delete">
                      <Button size="small" type="link" danger icon={<DeleteOutlined />} />
                    </Tooltip>
                  </Popconfirm>
                </Space>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <Card
      headStyle={{
        backgroundColor: isActive ? "#1890ff" : "#fafafa",
        color: isActive ? "#fff" : "#000",
      }}
      title={<div onClick={() => onUser && onUser(user)}>{user.user.name}</div>}
      key={user.user.id}
      size="small"
      className="user-info-card"
    >
      <Descriptions column={1} size="small">
        <Descriptions.Item>
          <Space>
            <EnvironmentOutlined />
            <span> {user.profile?.location?.addr}</span>
          </Space>
        </Descriptions.Item>
      </Descriptions>
      {orgRoles.map((o) => school(o))}
      {noSchoolChildren.length > 0 && school({ org: { id: "null", name: "No School" }, children: noSchoolChildren })}
    </Card>
  );
});
